import Button from './button';
import defaultsDeep from 'lodash-es/defaultsDeep';
import lookAndFeel from '../lookAndFeel';

var icon =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z' /%3E%3C/svg%3E";

export default class ReloadButton extends Button {
  renderElement() {
    // console.log('renderReloadButton', control, options, instance, path);
    this._controlOptions = defaultsDeep(this._controlOptions, {
      isReload: true,
      label: {
        align: 'right',
        text: 'Reload<br>',
        visible: false,
        style: { normal: { padding: '4px 12px' } },
      },
      icon: { position: 'left' },
      style: {
        minimal: true,
        normal: {
          width: '32px',
          height: '32px',
          top: '8px',
          left: 'auto',
          right: '8px',
        },
      },
    });
    if (this._controlOptions.style.minimal) {
      this._controlOptions = defaultsDeep(this._controlOptions, {
        style: {
          normal: {
            backgroundColor: 'rgba(0,0,0,0)',
            boxShadow: 'none',
            borderStyle: 'none',
            opacity: 0.2,
          },
          hover: {
            opacity: 1,
            backgroundColor: 'rgba(0,0,0,0)',
            boxShadow: 'none',
          },
        },
      });
    }

    let scheme = lookAndFeel(
      this._controlOptions.lookAndFeel,
      this._controlOptions.style.normal.height
    );
    var libicon = _.find(this.instance.options.icons, ['name', this._controlOptions.icon.url]);
    if (libicon) {
      this._controlOptions.icon.url = libicon.url;
    }

    this._controlOptions.icon.url = (this._controlOptions.icon.url || icon).replace(
      '%23FFFFFF',
      scheme.schemeForeground.replace('#', '%23')
    );
    // const trigger = options.trigger;
    // options.trigger = function(options, instance, control, path, ev) {
    //   instance.reload();
    //   if (trigger) {
    //     if (!isFunction(trigger)) {
    //       console.error("reloadButton's click trigger should be a function", trigger);
    //     } else {
    //       trigger.apply(this, [options, instance, control, path, ev]);
    //     }
    //   }
    // };

    return super.renderElement();
  }
}
